export const inputsGridContainerCss = {
  marginTop: "32px",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "24px",
  rowGap: "36px",
  marginBottom: 36,
};

export const comboboxCss = {
  ul: {
    width: "100%",
    zIndex: 1,
  },
};
